<template>
  <div class="buyrecord">
    <!--头部信息-->
    <public-title>
      购买记录
      <span v-show="isGroup" class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title> 
    <div class="bg-white load-area">
      <div class="hyyheader d-flex">
        <el-button v-if="userLoginMessage.type == 6">度假产品</el-button>
        <el-select v-else v-model="value" placeholder="请选择" @change="activeName='all';getBuyRecords()">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
            <label slot="label" v-if="value == 6">{{item.label}}
              <span class="unread-msg" v-if="item.label == '待付款' && waitVerify.StoreNopayView > 0">{{waitVerify.StoreNopayView}}</span>
            </label>
            <label slot="label" v-if="value == 7">{{item.label}}
              <span class="unread-msg" v-if="item.label == '待付款' && waitVerify.StoreNopayPro > 0">{{waitVerify.StoreNopayPro}}</span>
            </label>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="d-center-around flex-wrap choos">
        <left-text-border class="w-45 mb-3" leftText="订单号" v-model="ordernum" />
        <left-text-border class="w-45 mb-3" leftText="产品名称" v-model="proname" />
        <div class="d-center">
          <left-text leftText="出行时间" />
          <el-date-picker
            size="small"
            v-model="outtime"
            type="date"
            placeholder="选择出行时间"
            value-format="timestamp">
          </el-date-picker>
        </div>
        <div class="d-right">
          <el-button type="primary" size="small" icon="el-icon-search" @click="current=1;getBuyRecords()">搜索</el-button>
        </div>               
      </div>
      <el-table
        :data="tableData"
        style="width: 98%">
        <el-table-column prop="oid" label="订单号" v-if="value == 6" key="1">
          <template slot-scope="scope">
            <el-popover class="w-100" placement="right" trigger="hover">
                {{scope.row.oid}}<span slot="reference">{{scope.row.oid | formatString(15)}}</span>
            </el-popover>
            <div>{{scope.row.title}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="产品名称" v-else key="2" show-overflow-tooltip />
        <el-table-column label="订单类型" v-if="value == 6" key="3">
          <template slot-scope="scope">
            {{scope.row.order_type | formatVar('ticketTopType')}}
          </template>
        </el-table-column>
        <el-table-column label="产品类型/出行时间" v-if="value == 7" key="4">
          <template slot-scope="scope">
            <div class="h6">{{scope.row.type == 1 ? '限时优惠' : '限时抢购'}}</div>
            <div>{{scope.row.date_in | formatTimestamp}}</div>
          </template>
        </el-table-column>
        <el-table-column label="出行日期" v-else key="5">
          <template slot-scope="scope">
            {{scope.row.date_in | formatTimestamp}}
          </template>
        </el-table-column>
        <el-table-column label="门票种类" v-if="value == 6" key="6">
          <template slot-scope="scope">
            {{scope.row.ticket_species | formatVar('ticketTypeArr')}}
          </template>
        </el-table-column>
        <el-table-column label="下单时间">
          <template slot-scope="scope">
            {{scope.row.time | formatTimestamp(1)}}
          </template>
        </el-table-column>
        <el-table-column prop="num" width="80" v-if="value == 7" label="购买数量" key="7" />
        <el-table-column label="订单金额">
          <template slot-scope="scope">
            {{scope.row.price + '元'}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <div :class="[orderStatus(scope.row.status, 0)]" v-if="value == 7">
              {{orderStatus(scope.row.status, 1)}}
            </div>
            <div v-else :class="[$GFUN.FormatColor(scope.row.status)]">
              {{scope.row.status | formatVar('SOrderStatus')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope"> 
            <!-- 如果新增购买记录类型，记得改type            -->
            <span class="text-link" @click="goDetail(scope.row.id)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" class="mt-4" v-show="total > 0"
        :total="total" :page-size="10" :current-page="current" @current-change="currentChange" />
    </div>  
  </div>
</template>

<script>
  import { mapState,mapGetters } from 'vuex'

  export default {
    name: 'BuyRecords',
    data() {
      return {
        activeName: 'all',
        ordernum: '',
        proname: '',
        outtime: '',
        tableData: [],
        total: 1,
        current: 1,
        value: '6',
        options: [{
          value: '6',
          label: '景区门票'
        },{
          value: '7',
          label: '度假产品'
        }]
      }
    },
    computed: {
      ...mapState(['userLoginMessage','waitVerify']),
      ...mapGetters(['storeInfo','isGroup']),
      tabs () {
        let arr = [{label: '全部',name: 'all'},{label: '待确认',name: '14'},{label: '已入住',name: '7'},
                    {label: '已完成',name: '9'},{label: '其他',name: '98,99,100'}]
        if (this.value == 6) arr[2].name = '8,21'
        return arr
      }
    },
    created() {
      if (this.userLoginMessage.type == 6) this.value = '7'
      this.getBuyRecords()
    },
    methods: {
      handleClick () {
        this.current = 1
        this.ordernum = ''
        this.proname = ''
        this.outtime = ''
        this.getBuyRecords()
      },
      goDetail (id) {
        let routeUrl
        if (this.value == 6) routeUrl = this.$router.resolve({name: 'OrderDetail', query: {orderType: 6, orderId: id,storeId: this.$route.query.storeId}});
        else routeUrl = this.$router.resolve({name:'VocationQR',query:{id,type:7,storeId: this.$route.query.storeId}});
        window.open(routeUrl.href, '_blank');
      },
      async getBuyRecords() {
        let res = await this.$axios.post('/pc/Common/getOrderList',{
          store_id: this.isGroup ? this.$route.query.storeId : this.storeInfo.storeId,
          order_style: this.value,
          name: this.proname,
          oid: this.ordernum,
          status: this.activeName == 'all' ? '' : this.activeName,
          date_in: this.outtime / 1000,
          page: this.current,
          num: 10,
        });
        if (res.code === '00000' || res.code === '99999') {
          this.tableData = res.data
          this.total = res.count
        }
      },
      orderStatus(val, num) {
        let status = {};
        switch (val) {
          case 8 : status = {title: '待支付', color: 'text-info'}; break;
          case 9 : status = {title: '已完成', color: 'text-success'}; break;
          case 14: status = {title: '待确认', color: 'text-blue'}; break;
          case 99: status = {title: '超时取消', color: 'text-muted'}; break;
          case 100: status = {title: '已取消', color: 'text-muted'}
        }
        switch (num) {
          case 0 : return status.color
          case 1 : return status.title
        }
      },
      currentChange (val) {
        this.current = val
        this.getBuyRecords()
      }
    }
  }
</script>

<style lang="scss" scoped>
.buyrecord{
  .hyyheader{
    .el-select,.el-button{
      margin-right: 100px
    }
  }
  .d-center-around{
    justify-content: space-between
  }
  .choos{
    width: 100%;
    margin: 40px 0
  }
  .unread-msg{
    top: 5px;
    left: 62px;
  }
}

</style>
